export enum RESERVATION_SEARCH_MODE {
  bookingReference = 'BOOKING_REFERENCE',
  checkinEmail = 'CHECKIN_EMAIL',
  both = 'BOTH',
}

export enum RESERVATION_SEARCH_METHOD {
  bookingReference = 'BOOKING_REFERENCE',
  checkinEmail = 'CHECKIN_EMAIL',
  guestNameCheckinDate = 'GUEST_NAME_CHECKIN_DATE',
}

export function modeToMethods(
  mode?: RESERVATION_SEARCH_MODE,
): RESERVATION_SEARCH_METHOD[] {
  if (mode === RESERVATION_SEARCH_MODE.bookingReference)
    return [RESERVATION_SEARCH_METHOD.bookingReference];
  if (mode === RESERVATION_SEARCH_MODE.checkinEmail)
    return [RESERVATION_SEARCH_METHOD.checkinEmail];
  return [
    RESERVATION_SEARCH_METHOD.bookingReference,
    RESERVATION_SEARCH_METHOD.checkinEmail,
  ];
}

export enum RESERVATION_NOT_FOUND_BEHAVIOR {
  create = 'CREATE_IF_NOT_FOUND',
  doNotCreate = 'DO_NOT_CREATE_IF_NOT_FOUND',
}
